import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';

export const entrepreneurEnterpriseProfileRoutes: Routes = [
    {
        path: 'entrepreneur-enterprise-profile/individual',
        loadComponent: () =>
            import('../entrepreneur-enterprise-profile/eep-list/eep-list.component').then((m) => m.EepListComponent),
        data: { type: 'individual' },
        canActivate: [authGuard]
    },
    {
        path: 'entrepreneur-enterprise-profile/group',
        loadComponent: () =>
            import('../entrepreneur-enterprise-profile/eep-list/eep-list.component').then((m) => m.EepListComponent),
        data: { type: 'group' },
        canActivate: [authGuard]
    },
    {
        path: 'entrepreneur-enterprise-profile/shg-details/:id',
        loadComponent: () =>
            import('../entrepreneur-enterprise-profile/shg-details/shg-details.component').then(
                (m) => m.ShgDetailsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'entrepreneur-enterprise-profile/enterprise-member-list/:id',
        loadComponent: () =>
            import('../entrepreneur-enterprise-profile/enterprise-member-list/enterprise-member-list.component').then(
                (m) => m.EnterpriseMemberListComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'entrepreneur-enterprise-profile/preview-details/:id',
        loadComponent: () =>
            import('../entrepreneur-enterprise-profile/preview-details/preview-details.component').then(
                (m) => m.PreviewDetailsComponent
            ),
        canActivate: [authGuard]
    }
];

export const eepMobileRoutes: Routes = [
    {
        path: 'mobile/entrepreneur-enterprise-profile/home',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/home/home.component').then((m) => m.HomeComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/filter',
        loadComponent: () => import('../mobile/shared/filter/filter.component').then((m) => m.FilterComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/shg-member-list',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/shg-member-list/shg-member-list.component').then(
                (m) => m.ShgMemberListComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/add-shg',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/shg-member/add-shg/add-shg.component').then(
                (m) => m.AddShgComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/select-shg-member',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/shg-member/select-shg-member.component').then(
                (m) => m.SelectShgMemberComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/shg-details/:id',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/shg-details/shg-details.component').then(
                (m) => m.ShgDetailsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/member-details/:id',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/selected-member-details/selected-member-details.component').then(
                (m) => m.SelectedMemberDetailsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/new-enterprise-summary',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/new-enterprise-summary/new-enterprise-summary.component').then(
                (m) => m.NewEnterpriseSummaryComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/new-enterprise-plan-summary',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/new-enterprise-plan/screen-features/new-enterprise-plan-summary/new-enterprise-plan-summary.component').then(
                (m) => m.NewEnterprisePlanSummaryComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/new-enterprise-plan-view-summary',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/new-enterprise-plan-view-summary/new-enterprise-plan-view-summary.component').then(
                (m) => m.NewEnterprisePlanViewSummaryComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/task-list',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/task-list/task-list.component').then(
                (m) => m.TaskListComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/shg-list',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/shg-list/shg-list.component').then(
                (m) => m.ShgListComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/enterprises-list',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/enterprises-list/enterprises-list.component').then(
                (m) => m.EnterprisesListComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/enterprise-plan-list',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/enterprise-plan-list/enterprise-plan-list.component').then(
                (m) => m.EnterprisePlanListComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/new-enterprise',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/new-enterprise/new-enterprise.component').then(
                (m) => m.NewEnterpriseComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/select-scheme',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/select-scheme/select-scheme.component').then(
                (m) => m.SelectSchemeComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/entrepreneur-enterprise-profile/new-enterprise-plan',
        loadComponent: () =>
            import('../mobile/pages/entrepreneur-enterprise-profile/new-enterprise-plan/new-enterprise-plan.component').then(
                (m) => m.NewEnterprisePlanComponent
            ),
        canActivate: [authGuard]
    }
];
